const TOKENS = {
    access: 'access_token',
    homer: 'access_token_homer',
}

export {
    TOKENS,
}
